"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleType = void 0;
var RoleType;
(function (RoleType) {
    RoleType["MANAGER"] = "ROLE_MACHINE_MANAGER";
    RoleType["VIEWER"] = "ROLE_MACHINE_VIEWER";
    RoleType["ADMIN"] = "ROLE_ADMIN";
})(RoleType || (exports.RoleType = RoleType = {}));
